import { CloseSVG } from 'components/iconsSVG/close';
import { Button } from 'react-aria-components';

type FilterTagProps = {
  label: string;
  color?: string | null;
  onClick?: () => void;
  checked?: boolean;
  disabled?: boolean;
  type?: string;
  available?: boolean;
};

export function FilterTag({ color, onClick, label, checked = false, type, available = true }: FilterTagProps) {
  return (
    <Button
      type="button"
      onPress={() => {
        onClick?.();
      }}
      data-checked={checked}
      data-type={type}
      data-available={available}
      className="mr-0 flex max-w-full flex-shrink-0 flex-grow-0 cursor-pointer items-center gap-1.5 text-wrap border border-transparent bg-[--bg] px-2 py-1 text-left text-sm capitalize text-copy transition-all [--bg:transparent] data-[available=false]:pointer-events-none data-[available=false]:cursor-not-allowed data-[available=false]:opacity-50 data-[checked=true]:[--bg:#e0e0e0] data-[type=reset]:data-[checked=true]:[--bg:transparent] data-[checked=false]:hover:text-inverted data-[checked=true]:hover:[--bg:#e0e0e070] data-[checked=false]:hover:[--bg:theme(backgroundColor.neutral.inverted)]"
    >
      <span className="flex flex-wrap items-center gap-1.5 text-wrap [&>span]:first:inline-flex">
        {color ?
          <div style={{ background: color }} className="size-[15px] flex-shrink-0 rounded-full border border-[#e0e0e0]" />
        : null}
        <span className="">{label}</span>
      </span>
      {checked ?
        <span className="inline-flex font-semibold">
          <CloseSVG />
        </span>
      : null}
    </Button>
  );
}
